const caseMap = {
  'uppercase': (value) => value.toUpperCase(),
  'lowercase': (value) => value.toLowerCase(),
  'capitalize': (value) => value.split(' ').map(t => t.charAt(0).toUpperCase() + t.slice(1)).join(' '),
}

const debounce = (fn, delay) => {
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  }
}

const directive = (el, binding) => {
  if(el._transformCaseHandler) {
    el.removeEventListener('input', el._transformCaseHandler, false);
  }

  const transformCase = debounce((event) => {
    const value = event.target.value;
    if (value) {
      const caseType = binding.value ?? 'uppercase';
      let transform = caseMap[caseType];
      event.target.value = transform(value);
      event.target.dispatchEvent(new Event('input'));
    }
  }, 10);

  el._transformCaseHandler = transformCase;
  el.addEventListener('input', transformCase, false);
}

export default directive;